var productImageSlider = function () {
  $(".slider_images").slick({
    centerMode: !0,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 7e3,
    autoplay: !0,
    autoplaySpeed: 0,
    infinite: !0,
    cssEase: "linear",
    arrows: !1,
    responsive: [
      { breakpoint: 769, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  });
};

productImageSlider();
$(document).on("shopify:section:load", function (event) {
productImageSlider();
});


